
export const convertHoursToDecimal = (time: string): number => {
  if (!time || typeof time !== 'string') return 0;
  
  const parts = time.split(':');
  if (parts.length < 2) {
    const parsed = parseFloat(time);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  const hours = parseInt(parts[0], 10) || 0;
  const minutes = parseInt(parts[1], 10) || 0;
  
  return hours + minutes / 60;
};

export const formatDecimalToHours = (decimalHours: number): string => {
  if (typeof decimalHours !== 'number' || isNaN(decimalHours) || decimalHours < 0) {
    return '0:00';
  }
  const totalMinutes = Math.round(decimalHours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  
  return `${h}:${m.toString().padStart(2, '0')}`;
};

export const parseHoursFromAPI = (time: any): string => {
  if (!time && time !== 0) return '00:00';

  if (typeof time === 'number') {
    return formatDecimalToHours(time);
  }

  if (typeof time !== 'string') {
    return '00:00';
  }

  // Handle 'HH:MM:SS' or 'HH:MM'
  if (time.includes(':')) {
    const parts = time.split(':');
    const hours = parts[0].padStart(2, '0');
    const minutes = (parts[1] || '00').padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  
  // Handle decimal as string
  const decimalValue = parseFloat(time.replace(',', '.'));
  if (!isNaN(decimalValue)) {
    return formatDecimalToHours(decimalValue);
  }

  return '00:00';
};
